import React, { memo } from 'react';
export const TestimonialsSection = memo(function TestimonialsSection() {
  const testimonials = [{
    name: 'Nicolás R.',
    location: 'Córdoba',
    time: '11:42',
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    message: 'bro te juro que el primer día hice el ayuno dopamínico del tomo 2 y fue como resetear el cerebro en serio 😂 llevaba meses sin poder concentrarme más de 5 minutos. ese mismo día hice 3 horas de trabajo seguido sin tocar el celu. no puedo creer que antes pensaba que era un problema mío 🤦'
  }, {
    name: 'Martín G.',
    location: 'Buenos Aires',
    time: '09:15',
    avatar: 'https://randomuser.me/api/portraits/men/45.jpg',
    message: 'yo era de los que prometía cada lunes que iba a cambiar jaja. leí el tomo 1 en una tarde y entendí por qué nunca me funcionó la disciplina sola. esta semana ya terminé el proyecto que tenía parado hace 4 meses. con lo que facturé ya recuperé lo que pagué y me sobró 💪'
  }, {
    name: 'Diego F.',
    location: 'Rosario',
    time: '20:33',
    avatar: 'https://randomuser.me/api/portraits/men/67.jpg',
    message: 'me pasaba que me sentaba a trabajar y a los 10 minutos ya estaba en instagram sin darme cuenta. con el tomo 3 configuré el celu en modo guerra y rediseñé el escritorio. ahora el foco es automático. dos semanas para algo que intenté cambiar por años... nunca más vuelvo atrás 😤🙌'
  }, {
    name: 'Sebastián M.',
    location: 'Mendoza',
    time: '14:20',
    avatar: 'https://randomuser.me/api/portraits/men/22.jpg',
    message: 'hice la calculadora del tomo 1 y me di cuenta que estaba tirando $28000 dólares al año en tiempo perdido. fue un golpe en la cara necesario. las arreglé todas con el sistema de los 3 bloques y ya estoy facturando el doble que hace 3 meses 🔧💰'
  }, {
    name: 'Lucas P.',
    location: 'La Plata',
    time: '17:55',
    avatar: 'https://randomuser.me/api/portraits/men/54.jpg',
    message: 'dudé porque compré mil cursos de productividad que no me sirvieron. pero con la garantía me arriesgué. la primera semana avancé más en mi negocio que en los 2 meses anteriores. ya le recomendé el megapack a 3 amigos más 🙏🔥'
  }, {
    name: 'Carlos T.',
    location: 'Santa Fe',
    time: '08:47',
    avatar: 'https://randomuser.me/api/portraits/men/78.jpg',
    message: 'instalé el protocolo de encendido del tomo 2 y ahora mis mañanas son completamente distintas 🧠 antes arrancaba el día con el celu y ya estaba frito. ahora tengo 90 minutos de foco puro antes de que el mundo me interrumpa. el material es clarísimo, se entiende todo desde el primer tomo 🤙'
  }];
  return <section className="py-16 bg-gray-50 border-t border-gray-200 overflow-hidden" data-id="element-142">
      {/* Header */}
      <div className="text-center px-4 mb-6" data-id="element-143">
        <div className="inline-block bg-green-50 text-green-600 px-5 py-1.5 rounded-full font-black text-[11px] uppercase tracking-widest mb-4 border border-green-200" data-id="element-144">
          ✅ LO QUE DICEN LOS QUE YA LO TIENEN
        </div>
        <h2 className="text-[24px] md:text-4xl font-black text-gray-900 leading-tight" data-id="element-145">
          Gente común que dejó de scrollear{' '}
          <span className="text-yellow-500" data-id="element-146">y empezó a ejecutar:</span>
        </h2>
        <p className="text-gray-500 text-[11px] mt-3 max-w-sm mx-auto" data-id="element-147">
          * Los testimonios reflejan experiencias individuales. Los resultados
          pueden variar según el nivel de dedicación de cada persona.
        </p>
      </div>

      {/* Hint deslizar mobile */}
      <div className="flex items-center justify-center gap-2 mb-4 md:hidden" data-id="element-148">
        <span className="text-gray-500 text-[11px]" data-id="element-149">
          👈 Deslizá para ver más
        </span>
      </div>

      {/* Carrusel */}
      <div className="relative w-full" data-id="element-150">
        <div className="absolute left-0 top-0 bottom-0 w-8 md:w-16 bg-gradient-to-r from-gray-50 to-transparent z-10 pointer-events-none" data-id="element-151" />
        <div className="absolute right-0 top-0 bottom-0 w-8 md:w-16 bg-gradient-to-l from-gray-50 to-transparent z-10 pointer-events-none" data-id="element-152" />

        <div className="flex gap-4 px-4 py-2 overflow-x-auto scroll-smooth scrollbar-hide" style={{
        scrollSnapType: 'x mandatory',
        WebkitOverflowScrolling: 'touch'
      }} data-id="element-153">
          {testimonials.map((t, index) => <div key={index} className="flex-shrink-0 w-[270px] bg-[#111B21] rounded-2xl overflow-hidden border border-gray-300 shadow-md" style={{
          scrollSnapAlign: 'start'
        }} data-id="element-154">
              {/* Header WhatsApp */}
              <div className="bg-[#202C33] px-3 py-2.5 flex items-center gap-2.5" data-id="element-155">
                <img src={t.avatar} alt={t.name} loading="lazy" decoding="async" className="w-8 h-8 rounded-full object-cover flex-shrink-0" data-id="element-156" />
                <div className="flex-1 min-w-0" data-id="element-157">
                  <p className="text-white font-bold text-[12px] leading-tight" data-id="element-158">
                    {t.name}
                  </p>
                  <p className="text-gray-400 text-[10px]" data-id="element-159">📍 {t.location}</p>
                </div>
                <span className="text-gray-500 text-[10px]" data-id="element-160">{t.time}</span>
              </div>

              {/* Mensaje */}
              <div className="bg-[#0B141A] p-3" data-id="element-161">
                <div className="flex justify-end" data-id="element-162">
                  <div className="bg-[#005C4B] text-white text-[12px] leading-relaxed px-3 py-2 rounded-xl rounded-tr-sm max-w-[95%] shadow-sm" data-id="element-163">
                    {t.message}
                    <div className="flex items-center justify-end gap-1 mt-1" data-id="element-164">
                      <span className="text-[10px] text-green-300/60" data-id="element-165">
                        {t.time}
                      </span>
                      <svg className="w-3 h-3 text-blue-400" viewBox="0 0 16 11" fill="currentColor" data-id="element-166">
                        <path d="M11.071.653a.5.5 0 0 0-.707 0L4.54 6.477 2.121 4.059a.5.5 0 0 0-.707.707l2.772 2.772a.5.5 0 0 0 .707 0l6.178-6.178a.5.5 0 0 0 0-.707zM14.071.653a.5.5 0 0 0-.707 0L7.54 6.477l-.354-.353-.707.707.707.707a.5.5 0 0 0 .707 0l6.178-6.178a.5.5 0 0 0 0-.707z" data-id="element-167" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
});